/*******************************************************/
/*
/* Theses JS plugins may be used everywhere in aldjango.
/*
/*******************************************************/

$(document).ready(function() {

    // Passwords
    $('input[type=password]').hidePassword('focus', {
        toggle: { className: 'togglePassword', attr: { tabIndex: -1 } },
        wrapper: { enforceWidth: false }, // Prevent some strange behavior in positionning
        states: {
            shown: { toggle: {
                content: gettext('Cacher'),
                attr: { title: gettext('Cacher le mot de passe') }
            } },
            hidden: { toggle: {
                content: gettext('Voir'),
                attr: { title: gettext('Montrer le mot de passe') }
            } }
        }
    });

    // Prevent double submissions, copied from:
    // https://www.bram.us/2020/11/04/preventing-double-form-submissions/
    document.querySelectorAll('form').forEach(form => {
        form.addEventListener('submit', (e) => {

            // Prevent if already submitting
            if (form.classList.contains('is-submitting')) {
                e.preventDefault();
            }

            // Add class to hook our visual indicator on
            form.classList.add('is-submitting');
        });
    });
});
